import { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import Input from '../../Form/Field/Input.jsx'
import validate from './validate.js'
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx'
import Loader from '../../../../shared/components/Loader/Loader.jsx'
import Date from '../../Form/Field/Date.jsx'
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js'

export const name = 'DiplomeForm'

class DiplomeForm extends Component {
  render() {
    return (
      <div id={name}>
        <form autoComplete="off" onSubmit={this.props.handleSubmit}>
          <div className="row">
            <div className="col-md-6">
              <Field
                label="École ou formation"
                name="name"
                type="text"
                component={Input} />
            </div>
            <div className="col-md-6">
              <Field
                label="Année d'obtention"
                placeholder="aaaa"
                name="year"
                type="text"
                dateFormat="YYYY"
                viewMode="years"
                initialViewMode="years"
                component={Date} />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Field
                label="Intitulé du diplôme / formation"
                name="description"
                type="textarea"
                component={Input} />
            </div>
          </div>
          <input className="d-none" type="submit" />
          <FormGlobalErrors className="mt-0" errors={this.props.error} />
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit}></Loader>
      </div>
    )
  }
}

export default reduxForm({
  form: name,
  onSubmitFail: createOnSubmitFailHandler(name),
  validate
})(DiplomeForm)
